
/* eslint-disable */
import {UsersClub} from "@/generated-sources/gestioneclub-api";
import {PadelUser} from "@/models/user.models";
import {uppercase} from "@/services/mapping.service";
import {ActionTypes} from "@/store/action-types";
import {useStore} from "@/store/store";
import {defineComponent, onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";

export class PayInfo {
  colore: string;
  quota: number;
  stato: string;
}

export default defineComponent({
  name: "NormalPlayerItem",
  props: {
    booking_id: {
      type: String,
      default: null,
    },
    clubId: {
      type: String,
      default: null,
    },
    playerId: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    match: {
      type: Object,
      default: null,
    },
  },
  emits: ["refresh"],
  setup(props, {emit}) {
    const store = useStore();
    const {t, locale} = useI18n();
    const modalId = ref(null);
    const player = ref<UsersClub>(null);
    const urlFoto = ref<string>(null);
    const payInfo = ref<string>(null);
    const payStyle = ref<string>(null);
    /* COMPUTED */

    // SYSTEM
    onMounted(() => {
      load();
    });

    // FUNCTIONS
    function load(userId: string | null = props.playerId?.toString()) {
      _getUserclub(userId);
      _getUserinfo(userId);
      _getPaymentInfo(userId)
    }

    function _getUserclub(userId: string | null) {
      player.value = null;
      if (!userId) return;
      store
          .dispatch(ActionTypes.GET_USERCLUB_DETAIL, {
            clubId: props.clubId.toString(),
            userId,
          })
          .then((response) => {
            player.value = response;
          });
    }

    function _getUserinfo(userId: string | null) {
      urlFoto.value = null;
      if (!userId) return;
      store
          .dispatch(ActionTypes.GET_USER_BY_ID, {
            userId,
          })
          .then((response) => {
            urlFoto.value = response.user.urlFoto;
          });
    }

    function _getPaymentInfo(userId: string | null) {
      payInfo.value = ""
      payStyle.value = ""
      if (props.match.payments.length > 0) {
          const pay = props.match.payments[0]
          if (pay.userId == userId) {
            payInfo.value = (pay.quota / 100).toLocaleString('it-IT', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })+"€";
            if (pay.status == 'COMPLETED') {
              payInfo.value = "PAGATO "+payInfo.value
              payStyle.value = 'color: green;  text-align:center; font-size: 14px;'
            } else if(pay.status == 'SCHEDULED'){
              payInfo.value = "DA ADDEBITARE "+payInfo.value
              payStyle.value = 'color: yellow;  text-align:center; font-size: 14px;'
            }else {
              payInfo.value = "NON PAGATO "+payInfo.value
              payStyle.value = 'color: red; text-align:center'
            }
          } else {
            for (const slavePay of pay.slavePayments) {
              if (slavePay.userId == userId) {
                payInfo.value = (slavePay.quota / 100).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })+"€";
                if (slavePay.status == 'COMPLETED') {
                  payInfo.value = "PAGATO "+payInfo.value
                  payStyle.value = 'color: green; text-align:center; font-size: 14px;'
                } else if(pay.status == 'SCHEDULED'){
                  payInfo.value = "DA ADDEBITARE "+payInfo.value
                  payStyle.value = 'color: yellow;  text-align:center; font-size: 14px;'
                } else {
                  payInfo.value = "NON PAGATO "+payInfo.value
                  payStyle.value = 'color: red;  text-align:center; font-size: 14px;'
                }
              }
          }
        }
      }
    }

    function showModal(id) {
      modalId.value = id;
    }

    function hideModal() {
      modalId.value = null;
    }

    function userSelected(user: PadelUser) {
      if (user) {
        // HIDE
        hideModal();

        // SUBSCRIBE
        store
            .dispatch(ActionTypes.SUBSCRIBE_TO_GAME_V2, {
              booking_id: props.booking_id.toString(),
              wesmash_user_id: user.id,
              spot: (props.index as number) + 1,
            })
            .then(() => {
              load(user.id);
              emit("refresh");
            });
      }
    }

    function removePlayer() {
      // HIDE
      hideModal();

      // SUBSCRIBE
      store
          .dispatch(ActionTypes.UNSUBSCRIBE_FROM_GAME_V2, {
            booking_id: props.booking_id.toString(),
            wesmash_user_id: props.playerId.toString(),
          })
          .then(() => {
            load(null);
            emit("refresh");
          });
    }

    return {
      t,
      locale,
      uppercase,

      // DATA
      modalId,
      player,
      urlFoto,
      payInfo,
      payStyle,

      // METHIDS
      showModal,
      hideModal,
      userSelected,
      removePlayer,
    };
  },
});
